import APIClient from '../../../common/APIClient';
import { toggleShowAlert, displayError, SUCCESS_ALERT, MAX_ITEMS_IN_PAGE } from '../commonActions';

const FETCH_CLIENTS = 'FETCH_CLIENTS';
const SET_CLIENT_FIELD_CHANGE = 'SET_CLIENT_FIELD_CHANGE';
const SET_CLIENT = 'SET_CLIENT';
const RESET_CLIENT = 'RESET_CLIENT';
const CLIENT_FILTER = 'CLIENT_FILTER';

export const SET_CLIENTS_PAGINATION = 'SET_CLIENTS_PAGINATION';
export const RESET_CLIENTS_PAGINATION = 'RESET_CLIENTS_PAGINATION';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const fetchClients = () => {
  return (dispatch, getState) => {
    client().get(
      '/clients/list'
    ).then(json => {
      const result = json.data;
      if (result) {
        let clients = result.data;
        if (clients.length === 0) {
          clients = null
        }
        else {
          let numItems = clients.length;
          let min = getState().clients.min;
          let max = numItems < MAX_ITEMS_IN_PAGE ? numItems : getState().clients.max;
          
          const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);
          
          dispatch({type: SET_CLIENTS_PAGINATION, numItems, min, max, totalPages});
        }
        dispatch ({type: FETCH_CLIENTS, clients});
      }
    }).catch(error => {
      dispatch(displayError(error));
    });
  }
}

export const getClient = (clientCode) => {
  return (dispatch) => {
    client().get(
      'clients/get', {
        params: {
          client_code: clientCode
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        const client = result.data;
        dispatch({type: SET_CLIENT, client});
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const handleInputChange = (e) => {
  return (dispatch) => {
    const id = e.target.id;
  
    const value = {
      [id]: e.target.value
    }

    dispatch({type: SET_CLIENT_FIELD_CHANGE, value})
  }
}

export const upsertClient = (action = null, callback = null) => {
  return (dispatch, getState) => {
    const clientObj = getState().clients.client;
    
    let endpoint = 'clients/create';
    let message = 'Client has been successfully created.';

    if (action === 'UPDATE_CLIENT') {
      endpoint = 'clients/update';
      message = 'Client has been successfully updated.';
    }

    client().post(
      endpoint, 
      clientObj
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
        if (callback) {
          callback();
        }
      }
    }).catch(error => {
      dispatch(displayError(error))
    })
  }
}

export const filterClients = (filter) => {
  return (dispatch) => {
    dispatch({type: CLIENT_FILTER, filter});
  }
}

export const resetClient = () => {
  return (dispatch) => {
    dispatch({type: RESET_CLIENT});
  }
}